module.exports = __webpack_public_path__ + "static/media/suraj_yerkal.0f8ed681.png";